<template>
  <div class="l-content">
    <div class="text-title">{{mTitle}}</div>
    <div class="d-md-flex justify-content-center col-md-12">
      <form class="col-md-8 mt-5">
        <!-- row 1 -->
        <div class="form-row">
          <div class="d-md-flex justify-content-between col-md-12">
            <div class="form-group col-md-6">
              <label for="inputName">Name</label>
              <input type="text"
                     class="form-control"
                     :class="{'pulse__warning': mForm.nameInvalid}"
                     id="inputName" v-model="mForm.name" placeholder="Enter name">
            </div>
            <div class="form-group col-md-6">
              <label for="inputEmail">Email</label>
              <input type="email"
                     class="form-control"
                     :class="{'pulse__warning': mForm.emailInvalid}"
                     id="inputEmail" v-model="mForm.email" placeholder="Enter email">
            </div>
          </div>
        </div>
        <!-- row 2 -->
        <div class="form-group col-md-12">
          <label for="inputPhone">Phone</label>
          <input type="tel"
                 class="form-control"
                 :class="{'pulse__warning': mForm.phoneInvalid}"
                 id="inputPhone" v-model="mForm.phone" placeholder="Enter phone number">
        </div>
        <!-- row 3 -->
        <div class="form-group col-md-12">
          <label for="inputMessage"></label>
          <textarea
              class="form-control"
              :class="{'pulse__warning': mForm.messageInvalid}"
              id="inputMessage" rows="4" v-model="mForm.message" placeholder="Type your message here..."></textarea>
        </div>
        <!-- submit -->
        <div class="form-group col-md-12">
          <button type="submit" class="btn btn-primary col-md-12 text-white bg-dark" @click="onSubmit">Submit</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import logger from '../utils/logger'
import ApiHelper from '../webapi/ApiHelper'
import dataHelper from '../utils/dataHelper'

const LOG_TAG = 'RowContactUs'

export default {
  name: 'RowQuote',
  data () {
    return {
      // mTargetUrl: 'http://bot-api.bettersense.io:1880/contact_form',
      mTargetUrl: 'https://hooks.slack.com/services/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',
      mTitle: 'Contact Us',
      mForm: {
        name: '',
        nameInvalid: false,
        email: '',
        emailInvalid: false,
        phone: '',
        phoneInvalid: false,
        message: '',
        messageInvalid: false
      }
    }
  },
  methods: {
    resetForm () {
      const vm = this
      vm.mForm.name = ''
      vm.mForm.email = ''
      vm.mForm.phone = ''
      vm.mForm.message = ''
    },
    resetFormState () {
      const vm = this
      vm.mForm.nameInvalid = false
      vm.mForm.emailInvalid = false
      vm.mForm.phoneInvalid = false
      vm.mForm.messageInvalid = false
    },
    validateForm () {
      const vm = this
      logger.d(LOG_TAG, 'validateForm', vm.mForm)
      // always reset state
      vm.resetFormState()
      if (vm.mForm.name.length === 0) {
        vm.mForm.nameInvalid = true
        vm.$notify({
          group: 'notification',
          type: 'error',
          title: 'Error',
          text: 'Oops! you have forgotten to leave your name.'
        })
        return false
      } else if (!dataHelper.validateEmail(vm.mForm.email)) {
        vm.mForm.emailInvalid = true
        vm.$notify({
          group: 'notification',
          type: 'error',
          title: 'Error',
          text: 'Oops! please input correct email'
        })
        return false
      } else if (!dataHelper.validatePhone(vm.mForm.phone)) {
        vm.mForm.phoneInvalid = true
        vm.$notify({
          group: 'notification',
          type: 'error',
          title: 'Error',
          text: 'Oops! please input correct phone number.'
        })
        return false
      } else if (vm.mForm.message.length === 0) {
        vm.mForm.messageInvalid = true
        vm.$notify({
          group: 'notification',
          type: 'error',
          title: 'Error',
          text: 'Oops! you have forgotten to leave your message.'
        })
        return false
      }
      return true
    },
    onSubmit (event) {
      //
      event.preventDefault()
      const vm = this
      const url = ApiHelper.createUrl(vm.mTargetUrl)
      logger.d(LOG_TAG, 'onSubmit', url)
      if (vm.validateForm()) {
        const onResponse = function onResponse (response) {
          logger.d(LOG_TAG, 'onResponse', response)
          vm.resetForm()
          vm.$notify({
            group: 'notification',
            type: 'success',
            title: 'Success',
            text: 'We will be in touch with you as soon as possible!'
          })
        }
        const onError = function onError (error) {
          logger.d(LOG_TAG, 'onError', error)
          vm.resetForm()
          vm.$notify({
            group: 'notification',
            type: 'error',
            title: 'Error',
            text: 'Oops! something went wrong, please try again.'
          })
        }
        const payload = {
          fields: [
            {
              title: 'Contact Request',
              value: `Name: ${vm.mForm.name} \n Email: ${vm.mForm.email} \n Phone: ${vm.mForm.phone} \n Message: ${vm.mForm.message}`
            }
          ]
        }
        ApiHelper.apiPost(
          url,
          payload,
          onResponse,
          onError
        )
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .l-debug {
    border-width: 1px;
    border-color: lightgray;
    border-style: dashed;
  }
  .l-content {
    display: inline-block;
    width: 100%;
    min-height: 12rem;
    text-align: left;
  }
  .text-title {
    display: inline-block;
    width: 100%;
    color: #3c94a4;
    font-weight: lighter;
    font-size: 3rem;
    margin-top: 6rem;
    text-align: center;
  }
  .pulse__warning {
    animation: pulse__warning 1.6s infinite;
  }
  @-webkit-keyframes pulse__warning {
    0% {
      -webkit-box-shadow: 0 0 0 0 rgba(223, 0, 0, 0.4);
    }
    70% {
      -webkit-box-shadow: 0 0 0 4px rgba(223, 0, 0, 0);
    }
    100% {
      -webkit-box-shadow: 0 0 0 0 rgba(223, 0, 0, 0);
    }
  }
  @keyframes pulse__warning {
    0% {
      -moz-box-shadow: 0 0 0 0 rgba(223, 0, 0, 0.4);
      box-shadow: 0 0 0 0 rgba(223, 0, 0, 0.4);
    }
    70% {
      -moz-box-shadow: 0 0 0 4px rgba(223, 0, 0, 0);
      box-shadow: 0 0 0 4px rgba(223, 0, 0, 0);
    }
    100% {
      -moz-box-shadow: 0 0 0 0 rgba(223, 0, 0, 0);
      box-shadow: 0 0 0 0 rgba(223, 0, 0, 0);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RowContactUs.vue